<template>
    <div class="columns is-multiline">
        <div class="column is-3" v-for="c in commands" :key="c.id">
            <article :class="['message', 'is-small', 'is-clipped', c.color]">
            <div class="message-header" @click="c.show = !c.show">
                <p>{{c.command}}</p>
                <span class="icon"><fa icon="plus-circle" /></span>
            </div>
            <transition name="slideLeft">
            <div class="message-body has-text-justified" v-show="c.show">
                <b>Descripción:</b> {{c.description}}
                <br>
                <b>Método:</b> <code>{{c.method}}</code>
                <br v-if="c.requirement != ''">
                <span v-if="c.requirement != ''"><b>Requerimiento:</b> {{c.requirement}}</span>
                <br v-if="c.cost != ''">
                <span v-if="c.cost != ''"><b>Costo:</b> {{c.cost}} </span>
                <br v-if="c.condition != ''">
                <span v-if="c.condition != ''"><b>Condición:</b> {{c.condition}}</span>
                <br v-if="c.extra != ''">
                <span v-if="c.extra != ''"><b>Nota:</b> {{c.extra}}</span>
            </div>
            </transition>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    name:'Commands',
    beforeCreate(){
        this.$store.commit('setLoader', true)
        this.$store.dispatch('setPage', {
            location:{name:'commands',number:7},
            title:'Comandos del servidor',
            breadcrumb:[
                {name:'inicio',link:this.$store.state.baseUrl,active:true,icon:'home'},
                {name:'Comandos',link:'/comandos',active:false,icon:'code'}
            ]
        })
    },
    created() {
        this.$store.commit('setLoader', false)
    },
    computed: {
        commands() {
            return this.$store.getters.GetCommands
        }
    }
}
</script>

<style scoped>
    .column {
        padding: 0.15rem !important;
    }
    .message-header {
        cursor: pointer !important;
    }
</style>